import { Controller } from '@hotwired/stimulus'

// Drives the ESG preferences step (7/9):
//  - tints the selected choice card (no :has() / custom CSS — utility classes only),
//  - reveals the two follow-up questions only when the investor wants ESG products,
//  - enforces blocage B5: the "Continuer" button stays disabled (with an inline
//    message) until the confirmation question is answered "Oui".
// The backend validator remains the authoritative gate.
export default class extends Controller {
  static targets = ['submit', 'followups', 'followupInput', 'wantsEsg', 'confirmation', 'blockMessage']

  connect() {
    this.sync()
  }

  sync() {
    const wantsEsg = this.checkedValue(this.wantsEsgTargets)
    const isYes = wantsEsg === 'true'

    // Tint the selected choice card. Toggle each colour as a mutually-exclusive
    // pair so two competing utilities are never applied at once.
    this.wantsEsgTargets.forEach((radio) => {
      const card = radio.closest('label')
      card.classList.toggle('border-secondary-600', radio.checked)
      card.classList.toggle('bg-secondary-50', radio.checked)
      card.classList.toggle('border-gray-300', !radio.checked)
      card.classList.toggle('bg-white', !radio.checked)
    })

    // Toggle the Bootstrap display classes rather than the `hidden` attribute:
    // `.d-flex` / `.d-block` use `!important`, which would override `[hidden]`.
    this.followupsTarget.classList.toggle('d-flex', isYes)
    this.followupsTarget.classList.toggle('d-none', !isYes)
    this.followupInputTargets.forEach((input) => {
      input.disabled = !isYes
      input.required = isYes
    })

    const blocked = isYes && this.checkedValue(this.confirmationTargets) === 'false'
    // Toggle both classes as a mutually-exclusive pair: `.d-none` is defined after
    // `.d-block` in the compiled CSS, so keeping both would let `.d-none` win.
    this.blockMessageTarget.classList.toggle('d-block', blocked)
    this.blockMessageTarget.classList.toggle('d-none', !blocked)

    this.submitTarget.disabled = !this.element.checkValidity() || blocked
  }

  checkedValue(radios) {
    return radios.find((radio) => radio.checked)?.value
  }
}
